import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import PaidAdUpdate from 'components/PaidAd/Update';

const ScreenAutoUpdate = ({ match }) => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={9} md={8} lg={7}>
      <PaidAdUpdate id={match.params.id} />
    </GridItem>
  </GridContainer>
);

ScreenAutoUpdate.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default ScreenAutoUpdate;
